import { render } from "./BaseFullscreenLoader.vue?vue&type=template&id=4a4b9329&scoped=true"
import script from "./BaseFullscreenLoader.vue?vue&type=script&lang=js"
export * from "./BaseFullscreenLoader.vue?vue&type=script&lang=js"

import "./BaseFullscreenLoader.vue?vue&type=style&index=0&id=4a4b9329&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a4b9329"]])

export default __exports__